<div class="input">
    <label *ngIf="label" [ngClass]="new ? 'new-display' : ''">
      {{label}}
      <span *ngIf="hint"> - {{hint}}</span>
      <span *ngIf="new" class="new">New</span>
    </label>
    <ng-content></ng-content>
  </div>